export default __webpack_public_path__ + "static/media/drumstick.21c4e074.png";